module.exports = __webpack_public_path__ + "static/media/chrome-desktop-step-1.168a4f48.png";